import axiosClient from './axiosClient';

export const GoogleAuthService = {
    async handleGoogleResponse(response: any, onSuccess?: () => void) {
        try {
            const result = await axiosClient.post('/auth/google/customer-callback', {
                credential: response.credential
            });

            if (onSuccess) {
                onSuccess();
            }
            return result.data;
        } catch (error) {
            console.error('Google auth error:', error);
            throw error;
        }
    },

    async handleGoogleResponseForRenter(response: any, onSuccess?: () => void) {
        try {
            const result = await axiosClient.post('/auth/google/renter-callback', {
                credential: response.credential
            });

            if (onSuccess) {
                onSuccess();
            }
            return result.data;
        } catch (error) {
            console.error('Google auth error:', error);
            throw error;
        }

    },

    async handleGoogleResponseForRenterV2(_response: any, onSuccess?: () => void) {
        if (onSuccess) {
            onSuccess();
        }
        return true;
    },

    async handleGoogleResponseForRoommate(response: any, onSuccess?: (data: { roommate_id: string; household_id: string }) => void, onError?: (error: string) => void) {
        try {
            const result = await axiosClient.post('/auth/google/roommate-callback', {
                credential: response.credential
            });

            if (onSuccess) {
                onSuccess(result.data);
            }
            return result.data;
        } catch (error: any) {
            console.error('Roommate Google auth error:', error);
            const errorMessage = error.response?.data?.error || 'Authentication failed. Please try again.';
            if (onError) {
                onError(errorMessage);
            }
            throw error;
        }
    },

    async handleGoogleResponseForAdmin(response: any, onSuccess?: () => void, onError?: (error: string) => void) {
        try {
            const result = await axiosClient.post('/auth/google/admin-callback', {
                credential: response.credential
            });

            if (onSuccess) {
                onSuccess();
            }
            return result.data;
        } catch (error: any) {
            console.error('Admin Google auth error:', error);
            const errorMessage = error.response?.data?.error || 'Authentication failed. Please try again.';
            if (onError) {
                onError(errorMessage);
            }
            throw error;
        }
    }
}
